import { gql } from "@apollo/client";

export const GET_ALL_DOSAGE_CALCULATORS = gql`
  query GetAllDosageCalculators {
    getAllDosageCalculators {
      _id
      ref
      title
      keywords
      calculator
      isReviewed
    }
  }
`;
